import { Mail, Phone } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { getUser } from "@/lib/utils";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear(); // Get the current year
  const adminUser = getUser();

  return (
    <footer className="bg-white border-t mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-center md:text-left">
          {adminUser?.studioName && (
            <h3 className="text-lg font-semibold text-gray-800">{adminUser.studioName}</h3>
          )}

          {adminUser?.email && (
            <a
              href={`mailto:${adminUser.email}`}
              className="flex items-center text-primary hover:text-secondary transition-colors"
            >
              <Mail className="w-5 h-5 mr-2" />
              {adminUser.email}
            </a>
          )}

          {adminUser?.phone && (
            <a
              href={`tel:${adminUser.phone}`}
              className="flex items-center text-primary hover:text-secondary transition-colors"
            >
              <Phone className="w-5 h-5 mr-2" />
              {adminUser.phone}
            </a>
          )}
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mt-8">
          <a
            href="/terms/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {t('terms.title')}
          </a>
          <a
            href="/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {t('privacy.title')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;